import React from 'react';

import iconClose from '../../assets/img/close-line.svg';
import { ClickableDiv, ClickableImage } from '..';

import styles from './MobileDrawer.module.scss';

type Props = {
    isOpen: boolean;
    title: string;
    onClose: () => void;
    children: React.ReactNode;
}

const MobileDrawer = (props: Props) => {
  const { isOpen, title, onClose, children } = props;

  if (!isOpen) {
    return <></>;
  }

  return (
    <div className={styles.containerMobile}>
      <ClickableDiv
        className={styles.background}
        onClick={onClose}
      />
      <div className={styles.body}>
        <div className={styles.header}>
          <div className={styles.title}>{title}</div>
          <div className={styles.closeButtonWrapper}>
            <ClickableImage
              src={iconClose}
              className={styles.closeButton}
              alt="Close"
              onClick={onClose}
            />
          </div>
        </div>
        {children}
      </div>
    </div>
  );
};

export default MobileDrawer;
